import { themes } from '@theme/initThemes';
import layout1Settings from './Setting/LayoutSettings';

export const LayoutSettings = {
  activeLayout: 'layout1',
  activeTheme: 'md3Green',  // MD3 green EV theme
  perfectScrollbar: false,
  themes: themes,
  layout1Settings,
  secondarySidebar: {
    show: false,           // Hide secondary sidebar for cleaner MD3 layout
    open: false,
    theme: 'md3Green'
  },
  footer: {
    show: true,
    fixed: false,
    theme: 'md3Green'
  }
};
